import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=1e19d085&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=ts&"
export * from "./HelpCenter.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=1e19d085&prod&scoped=true&lang=css&"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=1e19d085&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e19d085",
  null
  
)

export default component.exports